export default {
  title: {
    id: 'bo_seller-options-batch_listing_creation-title',
    defaultMessage: 'Batch listing creation',
  },
  infoText: {
    id: 'bo_seller-options-batch_listing_creation-info_text',
    defaultMessage:
      'Create batches of listings all at once by generating a CSV file, entering your details, and uploading the file on the “Listings” page.',
  },
  question: {
    id: 'bo_seller-options-batch_listing_creation-question',
    defaultMessage: 'What type of listings do you want to create?',
  },
  createListings: {
    id: 'bo_seller-options-batch_listing_creation-create_listings',
    defaultMessage: 'Listings of existing items',
  },
  withNewItems: {
    id: 'bo_seller-options-batch_listing_creation-with_new_items',
    defaultMessage: 'Listings of new items',
  },
  withNewItemsInfo: {
    id: 'bo_seller-options-batch_listing_creation-with_new_items_info',
    defaultMessage:
      "New items will need to be added to Back Market's catalog first.",
  },
  generateTemplate: {
    id: 'bo_seller-options-batch_listing_creation-generate_template',
    defaultMessage: 'Generate CSV file',
  },
  chooseCategory: {
    id: 'bo_seller-options-batch_listing_creation-choose_category',
    defaultMessage:
      'Search for an item category for the new item you want to sell.',
  },
  chooseCategoryPlaceholder: {
    id: 'bo_seller-options-batch_listing_creation-choose_category_placeholder',
    defaultMessage: 'Search by item category name',
  },
  selectCategory: {
    id: 'bo_seller-options-batch_listing_creation-select_category',
    defaultMessage: 'Or select an item category.',
  },
  selectLevelThreePlaceholder: {
    id: 'bo_seller-options-batch_listing_creation-select_level_three',
    defaultMessage: 'Secondary item category',
  },
  selectLevelTwoPlaceholder: {
    id: 'bo_seller-options-batch_listing_creation-select_level_two',
    defaultMessage: 'Primary item category',
  },
  noResults: {
    id: 'bo_seller-options-batch_listing_creation-no_results',
    defaultMessage: 'No results',
  },
  confirmationMessage: {
    id: 'bo_seller-options-batch_listing_creation-confirmation_message',
    defaultMessage: 'Generate template for {selectedCategoryName}',
  },
  clear: {
    id: 'bo_seller-options-batch_listing_creation-clear',
    defaultMessage: 'Clear',
  },
}
